import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class JazzProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    if (ctx.scale.length >= 7) {
      const choice = this.pick(ctx, [
        [1, 4, 0], [1, 4, 0, 3], [5, 1, 4, 0], [0, 5, 1, 4], [1, 4, 5, 3], [0, 3, 1, 4],
      ]);
      return choice.map(deg => this.seventh(ctx, deg));
    }
    return [this.seventh(ctx, 0), this.seventh(ctx, 3), this.seventh(ctx, 0), this.seventh(ctx, 4)];
  }
}
